class CollectionSidebar extends HTMLElement {
  constructor() {
    super();

    this.thresholdToHideBanner =
      document.querySelector("#thresholdInput").value;

    this.currentPage = 1;
    this.addEventListener("change", this.handleCheck.bind(this));
    this.querySelector("#clear-all-filters")?.addEventListener(
      "click",
      this.clearAllFilters.bind(this)
    );
    this.querySelectorAll(".arrow").forEach((element) => {
      element.addEventListener("click", this.handleCategoryDropDown.bind(this));
    });
    this.querySelectorAll(".clear").forEach((element) => {
      element.addEventListener("click", this.handleClearCategory.bind(this));
    });
    this.bindLoadMoreEvent();
    this.bindMobileFilterButtonEvent();
    this.bindSortByEvent();
    document
      .querySelector("body > .modal-backdrop")
      .addEventListener("click", this.openMobileFilter.bind(this));
    document.addEventListener(
      "DOMContentLoaded",
      this.bindGoogleAnalyticsEvents.bind(this)
    );
  }
  handleCheck(e) {
    e.stopPropagation();
    const srcInput = e.srcElement;
    const value = srcInput.value;
    const { fetchUrlParams, historyUrlParam } = this.getUrlParams(value);
    this.fetchAndRender(fetchUrlParams, historyUrlParam).finally(() => {
      const categoryTitleContainer =
        srcInput.closest(".filter__category").previousElementSibling;
      const categoryItemsContainer = srcInput.closest(".filter__category");
      this.handleCategoryClearButton(
        categoryTitleContainer,
        categoryItemsContainer
      );
    });
  }
  async fetchAndRender(
    fetchUrlParams,
    historyUrlParam,
    isFetchingNewPage = false
  ) {
    if (!isFetchingNewPage) {
      this.showLoadingOverlay();
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
    console.log(
      `${window.location.origin}${window.location.pathname}?sections=collection__main-grid&${fetchUrlParams}`
    );
    return fetch(
      `${window.location.origin}${window.location.pathname}?sections=collection__main-grid&${fetchUrlParams}`
    )
      .then((response) => response.json())
      .then((data) => {
        var parser = new DOMParser();
        // Parse the text as HTML
        var parsedHTML = parser.parseFromString(
          data["collection__main-grid"],
          "text/html"
        );
        // next page or filter operation?
        if (isFetchingNewPage)
          document
            .querySelector(".collection__right-column #product-grid")
            .append(
              ...parsedHTML.querySelectorAll(
                ".collection__right-column #product-grid > div"
              )
            );
        else {
          this.mapServerInputToDomInputs(
            parsedHTML.querySelectorAll("collection-sidebar input")
          );
          document.querySelector(".collection__right-column").innerHTML =
            parsedHTML.querySelector(".collection__right-column").innerHTML;
          this.bindLoadMoreEvent();
          this.bindMobileFilterButtonEvent();
          this.bindSortByEvent();
          this.hideBannerIfItemsBellowThreshold(this.thresholdToHideBanner);
        }

        this.handleDisplayLoadMoreButton(parsedHTML);

        if (historyUrlParam.includes("filters")) this.showClearAll();
        else this.hideClearAll();
        history.pushState(null, null, `?${historyUrlParam}`);
      })
      .finally(() => {
        this.classList.remove("open");
        this.hideModalBackdrop();
      })
      .catch((err) => {
        console.log(err);
      });
  }
  handleDisplayLoadMoreButton(parsedHTML) {
    const nextPageButtonFromServer = parsedHTML.querySelector(
      ".collection__right-column .collection__load-more-container button"
    );
    // next page exist?
    if (nextPageButtonFromServer)
      document.querySelector(
        ".collection__right-column .collection__load-more-container"
      ).style.display = "flex";
    else
      document.querySelector(
        ".collection__right-column .collection__load-more-container"
      ).style.display = "none";
  }
  getUrlParams(clickedFilterValue, removeCategory = false) {
    var urlParams = new URLSearchParams(window.location.search);

    var paramValue = urlParams.get("filters");
    var newValue = clickedFilterValue;
    // Check if the parameter exists
    if (paramValue !== null) {
      const values = paramValue.split(" ");
      const exists = values.includes(clickedFilterValue);

      if (exists) {
        var newValue = values
          .filter((value) => value !== clickedFilterValue)
          .join(" ");
      } else {
        var newValue = `${paramValue} ${clickedFilterValue}`;
      }
    }
    if (newValue.length > 0) urlParams.set("filters", newValue);
    else urlParams.delete("filters");

    const historyUrlParam = urlParams.toString();
    urlParams.set("requestedPage", 1);
    this.setPage(1);
    return { fetchUrlParams: urlParams.toString(), historyUrlParam };
  }
  showClearAll() {
    const filterButton = this.querySelector("#clear-all-filters");
    if (filterButton) filterButton.style.display = "flex";
  }
  hideClearAll() {
    const filterButton = this.querySelector("#clear-all-filters");
    if (filterButton) filterButton.style.display = "none";
  }
  clearAllFilters() {
    const clear = true;
    const value = null;
    var urlParams = new URLSearchParams(window.location.search);

    urlParams.delete("filters");
    const historyUrlParam = urlParams.toString();
    urlParams.set("requestedPage", 1);
    this.setPage(1);
    const fetchUrlParams = urlParams.toString();

    this.fetchAndRender(fetchUrlParams, historyUrlParam).finally(() => {
      this.querySelectorAll("input").forEach(
        (input) => (input.checked = false)
      );
    });
  }
  mapServerInputToDomInputs(serverSideBarInputs) {
    serverSideBarInputs.forEach((input) => {
      const inputInDom = this.querySelector(`#${input.id}`);
      if (input.disabled) {
        inputInDom.disabled = true;
        inputInDom.nextElementSibling.classList.add("filter__disabled");
      } else {
        inputInDom.disabled = false;
        inputInDom.nextElementSibling.classList.remove("filter__disabled");
        if (input.checked) {
          inputInDom.nextElementSibling.classList.add("active");
        } else {
          inputInDom.nextElementSibling.classList.remove("active");
        }
      }
    });
  }
  handleCategoryDropDown(e) {
    const target = e.currentTarget;
    target.querySelector("span").classList.toggle("open");
    target.closest(".filter_title").nextElementSibling.classList.toggle("open");
  }
  handleClearCategory(e) {
    const clearCategoryValues = (categoryTitleContainer) => {
      const categoryTitleValue =
        categoryTitleContainer.getAttribute("data-title");
      var urlParams = new URLSearchParams(window.location.search);
      var paramValue = urlParams.get("filters");
      let newFiltersValue = "";
      paramValue.split(" ").forEach((item) => {
        const categoryTitle = item.split("_")[0];
        if (categoryTitle !== categoryTitleValue)
          newFiltersValue += `${newFiltersValue} ${item}`;
      });
      return { newFiltersValue, urlParams };
    };
    const target = e.currentTarget;
    const categoryTitleContainer = target.closest(".filter_title");
    var { newFiltersValue, urlParams } = clearCategoryValues(
      categoryTitleContainer
    );

    if (newFiltersValue.trim().length > 0)
      urlParams.set("filters", newFiltersValue.trim());
    else urlParams.delete("filters");

    const historyUrlParam = urlParams.toString();
    urlParams.set("requestedPage", 1);
    this.setPage(1);
    const fetchUrlParams = urlParams.toString();

    this.fetchAndRender(fetchUrlParams, historyUrlParam)
      .then(() => {
        const categoryValuesContainer =
          categoryTitleContainer.nextElementSibling;
        categoryValuesContainer
          .querySelectorAll("input")
          .forEach((input) => (input.checked = false));
      })
      .finally(() => {
        const categoryItemsContainer =
          categoryTitleContainer.nextElementSibling;
        this.handleCategoryClearButton(
          categoryTitleContainer,
          categoryItemsContainer
        );
      });
  }
  handleCategoryClearButton(categoryTitleContainer, categoryItemsContainer) {
    var categoryStillFiltered = false;
    categoryItemsContainer.querySelectorAll("input").forEach((input) => {
      if (input.checked) categoryStillFiltered = true;
    });
    if (categoryStillFiltered)
      categoryTitleContainer.querySelector(".clear").classList.add("visible");
    else {
      categoryTitleContainer
        .querySelector(".clear")
        .classList.remove("visible");
    }
  }
  setPage(page) {
    this.currentPage = page;
  }
  getNextPage(e) {
    const loadMoreButton = e.target;
    loadMoreButton.disabled = true;

    var urlParams = new URLSearchParams(window.location.search);
    var historyUrlParam = urlParams.toString();
    urlParams.set("requestedPage", this.currentPage + 1);
    urlParams.set("variant", Math.floor(Math.random() * (100000 + 1)));
    var fetchUrlParams = urlParams.toString();
    const isNextPage = true;
    document
      .querySelector(".collection__load-more-container .loading-ring")
      .classList.toggle("visible");
    this.fetchAndRender(fetchUrlParams, historyUrlParam, isNextPage).finally(
      () => {
        loadMoreButton.disabled = false;
        document
          .querySelector(".collection__load-more-container .loading-ring")
          .classList.toggle("visible");
      }
    );
    this.setPage(this.currentPage + 1);
  }
  bindSortByEvent(e) {
    const sortBy = document.getElementById("SortBy");
    const self = this;
    sortBy.addEventListener("change", (e) => {
      const sortByValue = e.currentTarget.value;
      var urlParams = new URLSearchParams(window.location.search);
      urlParams.set("sort_by", sortByValue);
      const historyUrlParam = urlParams.toString();
      urlParams.set("requestedPage", 1);
      const fetchUrlParams = urlParams.toString();
      self.setPage(1);
      self.fetchAndRender(fetchUrlParams, historyUrlParam);
    });
  }
  bindLoadMoreEvent() {
    document
      .querySelector(
        ".collection__right-column .collection__load-more-container button"
      )
      ?.addEventListener("click", this.getNextPage.bind(this));
  }
  hideBannerIfItemsBellowThreshold(thresholdToHideBanner) {
    var numberOfItemsOrBannerShouldHide = thresholdToHideBanner;
    const lessThan10Items =
      document.getElementById("product-grid").querySelectorAll(".product-card")
        .length < numberOfItemsOrBannerShouldHide;
    if (lessThan10Items) {
      console.log("less than 10 items");
      
      document.querySelector(
        ".collection__red-banner-container"
      ).style.display = "none";
    }
  }
  bindMobileFilterButtonEvent() {
    document
      .getElementById("collection__filter-mobile")
      .addEventListener("click", this.openMobileFilter.bind(this));
  }
  bindGoogleAnalyticsEvents() {
    document
      .querySelector(".collection__right-column")
      .addEventListener("click", (e) => {
        const closestProductCard = e.target.closest(".product-card");
        if (closestProductCard) {
          const parentSku = closestProductCard.getAttribute("data-parent-sku");
          window.dataLayer.push({
            event: "select_item",
            ecommerce: {
              parent_sku: parentSku || null,
              items: [
                {
                  item_id: parentSku || null,
                  item_list_name:
                    document.querySelector(".collection__meta h1").innerText ||
                    null,
                },
              ],
            },
          });
        }
      });
  }
  hideModalBackdrop() {
    const modalBackDrop = document.querySelector("body > .modal-backdrop");
    modalBackDrop.style.display = "none";
    modalBackDrop.querySelector(".loading-ring").classList.add("visible");
  }
  showModalBackDrop() {
    const modalBackDrop = document.querySelector("body > .modal-backdrop");
    modalBackDrop.style.display = "flex";
    modalBackDrop.querySelector(".loading-ring").classList.remove("visible");
  }
  openMobileFilter() {
    if (!this.classList.contains("open")) {
      this.classList.add("open");
      this.showModalBackDrop();
    } else {
      this.classList.remove("open");
      this.hideModalBackdrop();
    }
  }
  showLoadingOverlay() {
    document
      .querySelector(".collection__filter-overlay")
      .classList.add("visible");
  }
}
customElements.define("collection-sidebar", CollectionSidebar);
